"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _events = require("events");

var _core = _interopRequireDefault(require("./core"));

var _const = require("./const");

var _util = require("./util");

var _createApplyChain = _interopRequireDefault(require("./create-apply-chain"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 基础插件
// @author Pluto <huarse@gmail.com>
// @create 2019/12/30 14:17
const APPLY_CHAIN = Symbol('plugin.applyChain');
const INVOKER = Symbol('plugin.invoker');
const MIDDLEWARE_INDEX_MAP = Symbol('plugin.middlewareIndexMap');

class Plugin extends _events.EventEmitter {
  /** @type Array<Function> */

  /** @type Map<Function, number> */
  constructor(core, props = {}) {
    super();
    this.id = (0, _util.uuid)();
    this[APPLY_CHAIN] = [];
    this[MIDDLEWARE_INDEX_MAP] = new Map();

    if (!(core instanceof _core.default)) {
      throw new TypeError('core must be an instance of Core');
    }

    this.core = core;
    this.props = props;
  }
  /**
   * @abstract
   */


  init() {}
  /**
   * @abstract
   */


  destroy() {}
  /**
   * 添加中间件
   * @param {Function} middleware
   * @param {number} [index]
   */


  use(middleware, index = this[APPLY_CHAIN].length) {
    if (typeof middleware !== 'function') {
      throw new TypeError('middleware must be a function');
    }

    this[MIDDLEWARE_INDEX_MAP].set(middleware, index);
    this[APPLY_CHAIN].push(middleware); // 按照传入的 index 排序 (asc)

    this[APPLY_CHAIN].sort((a, b) => {
      const indexA = this[MIDDLEWARE_INDEX_MAP].get(a);
      const indexB = this[MIDDLEWARE_INDEX_MAP].get(b);
      return indexA - indexB;
    });
    this[INVOKER] = undefined;
    return this;
  }
  /**
   * 创建并执行调用链
   * @param {any} options
   * @return {Promise<object>}
   */


  run(options = {}) {
    if (options.next) {
      throw new Error('options can not contain property: \'next\'');
    } // 缓存 invoke 方法，下次执行就不需要重新创建调用链


    this[INVOKER] = this[INVOKER] || (0, _createApplyChain.default)(this[APPLY_CHAIN], this);
    return this[INVOKER](options);
  }

}

exports.default = Plugin;
Plugin[_const.CLASS_SYMBOL] = _const.PLUGIN_CLASS;